<template>
  <v-container>

    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md10 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Indicadores área de {{this.area}}</h4>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.size"
                      v-for="(header,index) in headers2"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in indicadores" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombreIndicador}}</td>
                    <td style="text-align:center " :class="headers[1].size">{{item.cohorte1}}</td>
                    <td style="text-align:center " :class="headers[2].size">{{item.cohorte2}}</td>
                    <td style="text-align:center " :class="headers[3].size">{{item.cohorte3}}</td>
                    <td style="text-align:center " :class="headers[4].size">{{item.cohorte4}}</td>
                    <td style="text-align:center " :class="headers[5].size">{{item.cohorte5}}</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

   
    </v-layout>

  </v-container>
</template>


<script>


export default {
  data() {
    return {
   area: "",
 
      headers: [
        {
          text: "Indicadores",
          value: "name",
          size: "col-md-7 col-lg-7 col-sm-7 col-xs-7",
          border: "col-md-7 col-lg-7 col-sm-7 col-xs-7 th-border"
        },
        
        {
          text: "2015",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "2016",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "2017",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },

        {
          text: "2018",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "2019",
          value: "muy desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1 ",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }

      ],

      headers2: [
        {
          text: "",
          value: "name",
          size: "col-md-7 col-lg-7 col-sm-7 col-xs-7"
        },

        {
          text: "Últimos 5 años",
          value: "muy desacuerdo",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5 th-border"
        }
      ],

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },

      indicadores: [],
      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    //console.log("aqui va el nombreeee");
    this.initComponent();
  },
  methods: {

    initComponent() {
      this.getIndicadores();
    },



    getIndicadores() {
      if (this.$route.params.id == "1" ) this.area = "Gestión";
      if (this.$route.params.id =="2") this.area = "Pregrado";
      if (this.$route.params.id =="3") this.area = "Postgrado";
      if (this.$route.params.id =="4") this.area = "Investigación";
      if (this.$route.params.id =="5") this.area = "Vinculación con el medio";
      axios
        .get(
          process.env.ROOT_API +
            "/estadistica/getAllEstrategia?tipo=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.indicadores = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },

   

  
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto !important;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull-left {
  text-align: justify;
  padding: 5% !important;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 400px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 13px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/indicadores/IndicadorEvidencia.vue